// extracted by mini-css-extract-plugin
module.exports = {"logo-wrapper":"_2LJ7vtMzyplLhNHbzn0UUV","userArea":"y8J1HuLXe8ruFPFPfocLJ","slideoutWrap":"_2jkI0bQolR-ata-0UJLveN","slideoutButton":"_2aGtyy086eJ2NUwPGvyLGV"};